import React, { useState, useEffect, useContext, useRef } from "react";
import "./New_Highlight_Inner_Page.css";
import { useNavigate } from "react-router-dom";
import Common_Btn from "../../../common/common-btn/Common_Btn";
import { Col, Container, Row } from "react-bootstrap";
import { Button } from "bootstrap";
import Free_Consultation from "../../../home/free-consultation/Free_Consultation";
import { NewUpdates } from "../../../../utils/apis/subsidy-policy/SubsidyPolicy";
import { IDS } from "../../../../utils/common";
import { Context } from "../../../../utils/context";

const New_Highlight_Inner_Page = () => {
  const navigate = useNavigate();
  const notices = [
    {
      id: 1,
      title: "General Notice:",
      img: "/assets/images/subsidy/book.png",
      description:
        "Public Notice -Advisory dated 25.11.2025 reg Advisory to the Vendors registered under PMSG MBY",
      date: "Posted on 08 FEB",
    },
    {
      id: 2,
      title: "Scheme Guidelines:",
      img: "/assets/images/subsidy/set.png",
      description:
        "Public Notice -Advisory dated 25.11.2025 reg Advisory to the Vendors registered under PMSG MBY",
      date: "Posted on 08 FEB",
    },
    {
      id: 3,
      title: "General Notice:",
      img: "/assets/images/subsidy/book.png",
      description:
        "Public Notice -Advisory dated 25.11.2025 reg Advisory to the Vendors registered under PMSG MBY",
      date: "Posted on 08 FEB",
    },
    {
      id: 4,
      title: "Scheme Guidelines:",
      img: "/assets/images/subsidy/set.png",
      description:
        "Public Notice -Advisory dated 25.11.2025 reg Advisory to the Vendors registered under PMSG MBY",
      date: "Posted on 08 FEB",
    },
  ];

  const { IMG_URL } = useContext(Context);

  var HtmlToReactParser = require("html-to-react").Parser;
  var htmlToReactParser = new HtmlToReactParser();

  const [newupdate, setNewUpdate] = useState([]);

  const getNewUpdate = async () => {
    const res = await NewUpdates();

    if (res?.success) {
      setNewUpdate(res?.data?.data || []);
    }
  };

  useEffect(() => {
    getNewUpdate();
  }, []);

  return (
    <>
      <section className="New_Highlight_Inner_Page residential_service">
        <div className="container-fluid">
          <div className="breadcrumb_wrapper">
            <span className="breadcrumb_link" onClick={() => navigate(-1)}>
              Subsidy & Policies
            </span>
            <span className="breadcrumb_separator"> &gt; </span>
            <span className="breadcrumb_active">New Updates & Highlights</span>
          </div>

          <div className="inner_highlight_banner_holder">
            <div className="inner_highlight_banner">
              <img
                src="/assets/images/subsidy/inner-banner.png"
                alt="inner-banner"
                className="inner_banner"
              />
            </div>
            <div className="inner_content_holder">
              {newupdate.map((item) => (
                <div key={item.id} className="notice_card">
                  <Row className="align-items-center">
                    {/* Left Icon */}
                    <Col xs="12" lg="auto" md="auto" sm="auto">
                      <div className="notice_icon">
                        <img src={IDS?.IMG_URL + item?.image} className="notice_img" />
                      </div>
                    </Col>

                    {/* Content */}
                    <Col>
                      <h6 className="notice_title">{item.name}</h6>
                      <p className="notice_text">
                        {htmlToReactParser.parse(item.description)}
                      </p>
                    </Col>

                    {/* Right Section */}
                    <Col
                      xs="12"
                      lg="auto"
                      md="auto"
                      className="text-end download_btn"
                    >
                      <p className="notice_date">
                        -{" "}
                        {new Date(item.createdAt).toLocaleDateString("en-GB", {
                          day: "numeric",
                          month: "short",
                          year: "numeric",
                        })}
                      </p>
                      <a
                        href={IDS?.IMG_URL + item?.pdf}
                        download
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <Common_Btn text={"Download PDF"} />
                      </a>
                    </Col>
                  </Row>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>
      <Free_Consultation />
    </>
  );
};

export default New_Highlight_Inner_Page;
